<template>
	<div v-if="false"></div>
</template>
<script lang="js">
	import axios from 'axios'
	import { mapState } from 'vuex';
	import Api from '@/mixins/api';
	import { jwtDecode } from 'jwt-decode';
	import Helpers from '@/mixins/helpers';

	export default {
		name: 'QuantumLead',
		data: function(){
			return {
				isPosting: false,
				timerId1: null,
				timerId2: null
			}
		},
		computed: {
			...mapState({
				app: state => state.app,
				customer: state => state.customer,
				dealer: state => state.dealer,
				vehicle: state => state.vehicle,
				finance: state => state.finance,
				tpr: state => state.tpr,
				quantum: state => state.quantum,
				forgeRockApp: state => state.forgeRockApp
			}),
			accessToken(){
				return this.forgeRockApp.tokens.accessToken;
			},
			tprGuid(){
				return this.tpr.guestRateIdentifier;
			},
			omniGuid(){
				const obj = this.accessToken ? jwtDecode(this.accessToken) : {};
				return obj.omni_guid || '';
			},
			currentAppStep(){
				return this.app.step;
			},
			isNewLead(){
				return !!this.customer.licenseNumber && !this.hasPostedQuantumCreate;
			},
			pegaCase(){
				return this.tpr.pegaCase;
			},
			notQuantumId(){
				return this.app.notQuantumId;
			},
			hasPostedQuantumCreate(){
				return this.app.hasPostedQuantumCreate;
			},
			hasPostedQuantumUpdate(){
				return this.app.hasPostedQuantumUpdate;
			},
			hasAllNecessaryInfo(){
				return !!this.accessToken && (this.isNewLead || this.notQuantumId);
			},
		},
		methods: {
			getVehicleFinanceInformation(){
				const endOdometer = (this.app.kmsPerYear * this.app.loanTerm);
				const termInMths = (this.app.loanTerm * 12);
				const balloonValue = this.finance.financeType === 1 ? this.finance.gfv : this.finance.balloon;
				const dash = this.vehicle.produced.indexOf("-");
				const vehicleModelYear = this.vehicle.produced.substring(0, dash);
				const obj = {
					vehicleBasePrice: this.vehicle.price,
					depositTotal: this.finance.depositTotal,
					vehicleName: this.vehicle.model,
					vehicleVariant: this.vehicle.fullDescription,
					vehicleMake: this.vehicle.franchise.toUpperCase(),
					vehicleModelYear: vehicleModelYear,
					nvic: this.finance.nv,
					vehicleProductionDate: this.vehicle.produced + 'T00:00:00',
					isJointApplication: false,
					loanTermInMonths: termInMths,
					balloonAmount: balloonValue,
					endOfTermOdometerReading: endOdometer,
					rate_type: "",//deliberately blank for future use.
					campaign: "",//deliberately blank for future use.
					ageGroup: "",//deliberately blank for future use.
					materialCode: this.vehicle.materialCode,
					enquirySource: this.app.enquirySource.value,
					interestRate: this.finance.apr,
					comparisonRate: this.finance.comparisonRate,
					repaymentAmount: this.finance.monthlyPayment,
					vehicleImage: this.vehicle.image,
					expectedPurchase: this.customer.expectedPurchase,
					ContactMethod: this.customer.contactMethod == 'Mobile' ?  1 : 2,
					vehicleStockIndicator: !!this.vehicle.vehicleSpecificationID,
					vin: this.vehicle.vin,
					dealerAgencyFee: this.finance.dafQuantum,
					financeType: this.finance.financeType
				};

				console.log('getVehicleFinanceInformation', obj);
				if (!obj.expectedPurchase){
					delete obj.expectedPurchase;
				}
				if (!obj.vin){
					delete obj.vin;
				}
				return obj;
			},
			restoreUrl(){
				// omni_guid=0b7e9373-1325-4c90-9ec3-faea3277323f
				// &case=TPR-31021
				// &guid=949aa9cd-78bc-475b-993b-3370c6e815c1
				// &m=2L50980T1LB221G3
				// &tpr_source=2 // whatever the source was
				// &financeOptions=1234_3_15000
				const params = new URLSearchParams();
				params.set('omni_guid', this.omniGuid || '');
				params.set('case', this.pegaCase || '');
				params.set('guid', this.tprGuid || '');
				params.set('m', this.vehicle.materialCode || '');

				if (Helpers.getCookie("financeoptions")){
					const fo = [
						this.app.financeDeposit,
						this.app.loanTerm,
						(this.app.financeType == 4 ? this.app.balloonPercentage : this.app.kmsPerYear),
						this.app.financeType
					];
					params.set('financeOptions', fo);
				}
				else {
					const c = `${this.$store.state.app.financeDeposit}_${this.$store.state.app.loanTerm}_${this.$store.state.app.kmsPerYear}`;
					params.set('financeOptions', c);
				}

				if (this.$route.query.tpr_source){
					params.set('tpr_source', this.$route.query.tpr_source || '');
				}
				if (this.$route.query.b){
					params.set('b', this.$route.query.b);
				}
				if (this.$route.query.v){
					params.set('v', this.$route.query.v);
				}
				if (this.$route.query.ps){
					params.set('ps', this.$route.query.ps);
				}
				if (this.$route.query.utm_source){
					params.set('utm_source', this.$route.query.utm_source);
				}
				if (this.$route.query.utm_term){
					params.set('utm_term', this.$route.query.utm_term);
				}
				if (this.$route.query.utm_medium){
					params.set('utm_medium', this.$route.query.utm_medium);
				}
				if (this.$route.query.utm_campaign){
					params.set('utm_campaign', this.$route.query.utm_campaign);
				}
				if (this.$route.query.enquiry_source){
					params.set('enquiry_source', this.$route.query.enquiry_source);
				}
				if (this.$route.query.track_my_car_status){
					params.set('track_my_car_status', this.$route.query.track_my_car_status);
				}
				if (this.$route.query.model){
					params.set('model', this.$route.query.model);
				}
				if (this.$route.query.grade){
					params.set('grade', this.$route.query.grade);
				}
				console.log('RESTORE URL', `${location.protocol}//${location.host}/finance/restore-quote?${params.toString()}`);
				return `${location.protocol}//${location.host}/finance/restore-quote?${params.toString()}`
			},
			getCreateObj(){
				const wsid = this.dealer.dealerSites.filter(o => o.Suburb == this.customer.preferredDealership).map(o => o.WholesaleId).toString();

				const fn = this.customer.firstName.replace(/\d/g,'');
				const ln = this.customer.lastName.replace(/\d/g,'');
				if (fn.length < 2 || ln.length < 2) return null;
				return {
					dealerId: this.dealer.dealerID,
					stockDealerId: this.dealer.stockDealerID,
					financeEnquiryId: this.app.financeEnquiryId,
					guestInformation: {
						firstName: fn,
						lastName: ln,
						email: this.customer.email,
						telephone: this.customer.phone.replace(/\s/, ''),
						dateofBirth: (this.customer.dob) ? this.customer.dob : '1900-01-01T00:00:00',
						currAddressOwnerShip: parseInt(this.customer.livingStatus),
						driversLicenceNumber: this.customer.licenseNumber,
						driversLicenceState: this.customer.licenseOrigin == 'Overseas' ? '' : this.customer.licenseState,
						currSa1Code: this.customer.sa1Code,
						fullAddress: this.customer.address,
						streetAddress: this.customer.streetAddress,
						address: {
							unitNumber: this.customer.unitNo,
							streetNumber: this.customer.streetNo,
							streetName: this.customer.streetName,
							streetType: this.customer.streetType,
							suburb: this.customer.suburb,
							state: this.customer.state,
							postCode: this.customer.postcode
						},
						otherProperty: this.customer.otherProperty,
						bureauConsent: true,
						caseID: this.pegaCase,
						wholesaleID: wsid,
					},
					vehicleFinanceInformation: this.getVehicleFinanceInformation(),
					quoteGuid: this.omniGuid,
					retrieveQuoteUrl: this.restoreUrl(),
					accessToken: this.accessToken
				};
			},
			getUpdateObj(){
				return {
					caseID: this.pegaCase,
					quoteGuid: this.omniGuid,
					vehicleFinanceInformation: this.getVehicleFinanceInformation(),
					retrieveQuoteUrl: this.restoreUrl(),
					accessToken: this.accessToken
				};
			},
			setQuantumCookie(id){
				let dateexp = new Date(this.tpr.validityDate);
				let expires = "expires="+ dateexp.toString();
				let cookieData = ";" + expires + ';path=/';
				document.cookie = "notquantumid=" + id + cookieData;
			},
			createLead(){
				const url = Api.getQuantumLeadCreateApi();
				const obj = this.getCreateObj();
				console.log('createLead');
				if (!obj || this.isPosting || this.hasPostedQuantumCreate) return;
				this.isPosting = true;
				axios.post(url, obj).then(response => {
					this.isPosting = false;
					if (response.data.success){
						const id = response.data.createQuoteResponse.customer.quote.quoteId;
						this.$store.commit('setAppHasPostedQuantumCreate', true);
						this.$store.commit('setAppNotQuantumId', id);
						this.$store.commit('setQuantum', response.data);
						this.setQuantumCookie(id);
					}
				}).catch((error) => {
					this.isPosting = false;
					console.log(error);
				});
			},
			updateLead(){
				const url = Api.getQuantumLeadUpdateApi();
				const obj = this.getUpdateObj();
				if (!obj || this.isPosting || this.hasPostedQuantumUpdate) return;
				this.isPosting = true;
				axios.post(url, obj).then(response => {
					this.isPosting = false;
					if (response.data.success){
						this.$store.commit('setAppHasPostedQuantumUpdate', true);
						this.$store.commit('setQuantum', response.data);
					}
				}).catch((error) => {
					this.isPosting = true;
					console.log(error);
				});
			},
			handleAppStepChange(step){
				if (!this.tpr.guestRateIdentifier) return;
				if (this.isNewLead && step == 2){
					if (this.hasAllNecessaryInfo){
						this.createLead();
					}
					else {
						this.timerId1 = setInterval(() => {
							if (this.hasAllNecessaryInfo){
								clearInterval(this.timerId1);
								this.createLead();
							}
						}, 500);
					}
				}
				else if (!this.isNewLead && step == 3){//was summary
					if (this.hasAllNecessaryInfo){
						this.updateLead();
					}
					else {
						this.timerId2 = setInterval(() => {
							if (this.hasAllNecessaryInfo){
								clearInterval(this.timerId2);
								this.updateLead();
							}
						}, 500);
					}
				}
			}
		},
		watch: {
			tprGuid(v){
				if (v){
					this.handleAppStepChange(this.app.step);
				}
			},
			currentAppStep(v){
				this.handleAppStepChange(v);
			}
		},
		mounted(){
			const omniGuid = Helpers.getCookie('omniguid') || this.$route.query.omni_guid || this.omniGuid;
			console.log('mounted QuantumLead og', omniGuid, ' pc', this.pegaCase);
			if (this.pegaCase && !this.app.tprFormSubmitted && omniGuid){
				const url = Api.getQuantumLeadRetrieveApi(this.dealer.dealerID, this.tpr.pegaCase, omniGuid);
				axios.get(url).then(res => res.data).then(json => {
					const id = json.quoteID;
					console.log('quantum restore');
					if (id){
						this.$store.commit('setAppNotQuantumId', id);
						this.$store.commit('setQuantumRestore', json);
						this.setQuantumCookie(id);
					}
					// else {
					// 	this.$store.commit('setApp', { hasBadOmniGuid: true });
					// }
				}).catch((error) => {
					this.$store.commit('setAppHasBadOmniGuid', true);
					console.log('Error retrieving quantum lead:', error);
				});
			}
		}
	}
</script>
